import { Image4 } from "./image4";
import React from "react";

export const Gallery4 = (props) => {
  return (
    <div id="Youtube_thumbnails" className="text-center">
      <div className="container">
        <div className="section-title">
          <br></br><br></br>
          <h1>Quiz Thumbnail</h1>
        </div>
        <div className="row">
          <div className="portfolio-items">
            {props.data
              ? props.data.map((d, i) => (
                  <div
                    key={`${d.title4}-${i}`}
                    className="col-sm-6 col-md-3 col-lg-4"
                  >
                    <Image4
                      title5={d.title5}
                      largeImage4={d.largeImage4}
                      smallImage4={d.smallImage4}
                    />
                  </div>
                ))
              : "Loading..."}
          </div>
        </div>
      </div>
    </div>
    
  );
};

